import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState } from "react";
import classnames from "classnames";
import Swiper from "react-id-swiper";
import Icon from "../Icon";
import "./Gallery.scss";
export var Gallery = function Gallery(a) {
  var b = a.show,
      c = a.startIndex,
      d = a.onClose,
      e = a.colour,
      f = _objectWithoutProperties(a, ["show", "startIndex", "onClose", "colour"]),
      g = useState(null),
      h = _slicedToArray(g, 2),
      i = h[0],
      j = h[1],
      k = f.slides,
      l = {
    loop: !0,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      renderFraction: function renderFraction(a, b) {
        return "<span class=\"".concat(a, "\"></span> of <span class=\"").concat(b, "\"></span>");
      }
    },
    activeSlideKey: c.toString()
  },
      m = k.map(function (a, b) {
    var c = "object" == typeof a ? a.image : a;
    return /*#__PURE__*/React.createElement("div", {
      key: b,
      "data-hash": b + 1
    }, /*#__PURE__*/React.createElement("div", {
      className: "swiper-imagewrapper"
    }, /*#__PURE__*/React.createElement("img", {
      src: c,
      alt: ""
    })));
  });

  return b ? /*#__PURE__*/React.createElement("div", {
    className: classnames("ta-gallery", {
      active: b
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "share"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "share"
  }), "Share"), /*#__PURE__*/React.createElement(Icon, {
    icon: "grey" === e ? "close_grey" : "close",
    className: "close",
    onClick: d
  }), /*#__PURE__*/React.createElement("span", {
    className: "floorplan",
    onClick: function slideToFloorplan() {
      var a = k.findIndex(function (a) {
        return "floorplan" === a.icon;
      });
      (null !== i || -1 === a) && i.slideTo(a + 1);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "floorplan"
  }), "View floor plan"), /*#__PURE__*/React.createElement("div", {
    onClick: function slidePrev() {
      null !== i && i.slidePrev();
    },
    className: "swiper-button-prev"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrow_orange"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: function slideNext() {
      null !== i && i.slideNext();
    },
    className: "swiper-button-next"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrow_orange"
  })), /*#__PURE__*/React.createElement(Swiper, Object.assign({
    getSwiper: j
  }, l), m), ");") : null;
};
export default Gallery;